var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTablerpointfilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.54948C8.65312 5.54944 9.29186 5.74127 9.83689 6.10115C10.3819 6.46102 10.8092 6.97308 11.0657 7.57372C11.3222 8.17436 11.3966 8.83712 11.2797 9.47969C11.1627 10.1222 10.8596 10.7163 10.4079 11.1881C9.95621 11.6598 9.37589 11.9885 8.73902 12.1332C8.10215 12.278 7.43678 12.2325 6.82556 12.0023C6.21433 11.7722 5.68419 11.3675 5.30097 10.8387C4.91775 10.3098 4.69835 9.67998 4.67 9.02748L4.66667 8.88281L4.67 8.73815C4.70728 7.87998 5.0744 7.06933 5.69482 6.47525C6.31523 5.88117 7.14102 5.54953 8 5.54948Z",
    fill: "#020617"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerpointfilled);
export default __webpack_public_path__ + "static/media/tablerpointfilled.1b0f2f39e83f72c69ea4fff13e738a00.svg";
export { ForwardRef as ReactComponent };